import { render, staticRenderFns } from "./BuscaCliente.vue?vue&type=template&id=1bdeabc5&scoped=true"
import script from "./BuscaCliente.vue?vue&type=script&lang=js"
export * from "./BuscaCliente.vue?vue&type=script&lang=js"
import style0 from "./BuscaCliente.vue?vue&type=style&index=0&id=1bdeabc5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdeabc5",
  null
  
)

export default component.exports